import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({ vertical: true })`
  width: 100%;
  max-width: 1248px;
  margin: 0 auto;
  @media (max-width: 1288px) {
    padding: 0 20px;
  }
`;
